export async function fetcher(url) {
    if (process.env.REACT_APP_DISABLE_API === 'true') {
        return { success: true, data: [] };
    }

    const res = await fetch(url);

    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'An error occurred while fetching the data.');
    }

    return res.json();
}